import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setPreview as setPreviewAction } from "../../Actions/commonAction";
import "../../Assets/SCSS/components/Thumbnail.scss";
import { getUrlExtension, getFnameFromUrl } from "../../Handlers/getters";
import DeleteIcon from "../Icons/delete-small";
import EditIcon from "../Icons/edit-small";
import Dropzone from "react-dropzone";

const getThumbnailFromExt = ({ ext, url }) => {
  switch (ext) {
    case "jpg":
    case "jpeg":
    case "png":
      return <ImgThumbnail url={url} />;
    case "pdf":
      return <PdfThumbnail url={url} />;
    default:
      return <OtherThumbnail url={url} />;
  }
};

export const Thumbnail = (props) => {
  const URL = get(props, "doc.url", "");
  const ext = getUrlExtension(URL);
  const iconwrapper = !(ext == "jpg" || ext == "jpg" || ext == "png") && "top-140";
  return (
    <Grid>
      <Tooltip title={getFnameFromUrl(URL)} className="thumbnail-tooltip" placement="top-start">
        <div className="thumbnail-big-wrapper">
          {getThumbnailFromExt({ ext, url: URL })}
          <div className={`thumbnail-big-iconwrapper ${iconwrapper}`}
            // onClick={() => props.setPreview({ show: true, type: "doc", data: URL })}
            >
            <div>
              <div className="flex-1" />
              <span className="edit-icon-wrapper">
                <Dropzone className="width100 height100" onDrop={(e) => props.onEdit(e, props.doc)} multiple={false} accept={props.filetypes}>
                  <EditIcon {...props} />
                </Dropzone>
              </span>
              <span onClick={() => props.onDelete(props.doc)} className="delete-icon-wrapper">
                <DeleteIcon {...props} />
              </span>
            </div>
          </div>
        </div>
      </Tooltip>
    </Grid>
  );
};

const ImgThumbnail = ({ url }) => <img src={url} className="thumbnail-big" alt="img" />;

const PdfThumbnail = ({ url }) => (
  <div className="thumbnail-big text-align-center">
    <i className="material-icons thumbnail-big-pdficon">picture_as_pdf</i>
  </div>
);

const OtherThumbnail = ({ url }) => (
  <div className="thumbnail-big text-align-center">
    <i className="material-icons thumbnail-big-othersicon">attachment</i>
  </div>
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setPreview: setPreviewAction }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps,
)(Thumbnail);
